import AnimalIcon from 'Components/AnimalIcon';
import { Box, Drop } from 'grommet';
import { useRef, useState } from 'preact/hooks';

import NavMenuContent from '@/components/NavBar/NavMenuContent';
import NavMenuFooter from '@/components/NavBar/NavMenuFooter';

import style from './style.scss';

const Menu = () => {
  const buttonRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);

  return (
    <div className={style.menuContainer}>
      <Box
        margin={{ right: '16px' }}
        align="center"
        justify="start"
        ref={buttonRef}
        // using onclick for cursor pointer,
        // and onMouseDown to prevent reopening on avatar click
        onClick={() => {}}
        onMouseDown={() => setShowMenu(!showMenu)}
      >
        <AnimalIcon width={40} />
      </Box>

      {showMenu && (
        <Drop
          align={{ top: 'bottom', right: 'right' }}
          target={buttonRef.current}
          elevation="xlarge"
          onClickOutside={() => setShowMenu(false)}
          onClick={() => setShowMenu(false)}
          width={{ min: '280px' }}
        >
          <div className="preflight rounded-lg border">
            <NavMenuContent />
            <NavMenuFooter hideUpgradeButton className="my-3" />
          </div>
        </Drop>
      )}
    </div>
  );
};

export default Menu;
